export function toMadBundayAflTeamSalesforceString(aflTeam: string) {
  switch (aflTeam) {
    case 'Gold Coast':
      return 'GoldCoast'
    case 'Greater Western Sydney':
      return 'GreaterWesternSydney'
    case 'North Melbourne':
      return 'NorthMelbourne'
    case 'Port Adelaide':
      return 'PortAdelaide'
    case 'St Kilda':
      return 'StKilda'
    case 'West Coast':
      return 'WestCoast'
    case 'Western Bulldogs':
      return 'WesternBulldogs'
    default:
      return aflTeam
  }
}

export function toMadBundayNrlTeamSalesforceString(nrlTeam: string) {
  switch (nrlTeam) {
    case 'Gold Coast':
      return 'GoldCoast'
    case 'Melbourne Storm':
      return 'Melbourne'
    case 'North Queensland':
      return 'NorthQueensland'
    case 'South Sydney':
      return 'SouthSydney'
    case 'St George':
      return 'StGeorgeIllawarra'
    case 'Wests Sydney':
      return 'WestsTigers'
    default:
      return nrlTeam
  }
}

export function toMadBundayAflReadableString(aflTeam: string) {
  switch (aflTeam) {
    case 'GoldCoast':
      return 'Gold Coast'
    case 'GreaterWesternSydney':
      return 'Greater Western Sydney'
    case 'NorthMelbourne':
      return 'North Melbourne'
    case 'PortAdelaide':
      return 'Port Adelaide'
    case 'StKilda':
      return 'St Kilda'
    case 'WestCoast':
      return 'West Coast'
    case 'WesternBulldogs':
      return 'Western Bulldogs'
    default:
      return aflTeam
  }
}

export function toMadBundayNrlReadableString(nrlTeam: string) {
  switch (nrlTeam) {
    case 'GoldCoast':
      return 'Gold Coast'
    case 'Melbourne':
      return 'Melbourne Storm'
    case 'NorthQueensland':
      return 'North Queensland'
    case 'SouthSydney':
      return 'South Sydney'
    case 'StGeorgeIllawarra':
      return 'St George'
    case 'WestsTigers':
      return 'Wests Sydney'
    default:
      return nrlTeam
  }
}
